export const useIsProductionEnvironment = () => {
  return { isProd: process.env.REACT_APP_ENV === 'production' };
};
